/*
 * Module for the employer common area
*/

rs.module("application/sections/employer/commonarea",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls) {

            // Hook up click event to show the id card
            $.js(jsSelectors.idCardLink, { required: false }).click(_displayIdCard);

            //
            // Display the id card
            //
            var idLoaded = false;
            function _displayIdCard() {

                $(this).toggleClass(cssClasses.active);

                $.js(jsSelectors.idCard, { required: false }).toggle();

                if (!idLoaded) {
                    $.get(
                        backendUrls.getIdCard,
                        {
                            employerKey: $(this).data("employerkey")
                        })
                        .done(function (result) {
                            $.js(jsSelectors.idCard, { required: false }).html(result);
                        });

                    idLoaded = true;
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);